module.exports = __webpack_public_path__ + "img/use-template.1de8bc79.svg";